function updateQuantity(key, quantity) {
  if (quantity < 1) return removeItem(key);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }).then(() => location.reload());
}

function removeItem(key) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  }).then(() => location.reload());
}

function closeCart() {
  document.getElementById('cart-drawer-2').style.display = 'none';
}
